import { Checkbox } from '@nicejob-library/design-system/core';
import styled from 'styled-components';

export const CommunicationPreferencesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: 24px;
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 480px;
    width: 100%;
`;

export const BalloonsIconContainer = styled.div`
    font-size: 48px;
    color: ${({ theme }): string => theme.colors.blue500};
    margin-bottom: 24px;
`;

export const MainTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
`;

export const WelcomeTextContainer = styled.h1`
    font-family: 'Bogart';
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    color: ${({ theme }): string => theme.colors.grey900};
    margin: 0 0 12px 0;

    @media screen and (${({ theme }): string => theme.responsive_media_queries.tablet}) {
        font-size: 40px;
        line-height: 48px;
    }
`;

export const HeaderTextContainer = styled.p`
    font-family: 'Inter';
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }): string => theme.colors.grey600};
    margin: 0;
    max-width: 400px;
`;

export const PreferencesSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
    padding: 24px;
    background-color: ${({ theme }): string => theme.colors.grey50};
    border-radius: 12px;
`;

export const PreferencesSectionTitle = styled.p`
    font-family: 'Inter';
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }): string => theme.colors.grey600};
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.6px;
`;

export const PreferenceCheckbox = styled(Checkbox)`
    align-items: flex-start;

    label {
        font-size: 14px;
        line-height: 20px;
        color: ${({ theme }): string => theme.colors.grey700};
    }
`;

export const PreferenceLinkText = styled.a`
    color: inherit;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: ${({ theme }): string => theme.colors.blue500};
    }
`;
